import React, { useState, useEffect } from 'react';
import '../styles/HeroSection.css';

function HeroSection() {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    // Check if mobile on mount
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    // Initial check
    checkMobile();

    // Listen for resize events
    window.addEventListener('resize', checkMobile);

    // Cleanup
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const handleScrollDown = () => {
    const nextSection = document.querySelector('.about-section, .services-section');
    nextSection?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="hero-section">
      {/* Video Background - Portrait for mobile, Landscape for desktop */}
      <video
        className="hero-video"
        autoPlay
        muted
        loop
        playsInline
        key={isMobile ? 'mobile' : 'desktop'}
      >
        <source
          src={isMobile ? "/portrait-video.mp4" : "/Construction_Genie_Animation_Request.mp4"}
          type="video/mp4"
        />
      </video>

      {/* Dark Overlay */}
      <div className="hero-overlay"></div>

      {/* Content */}
      <div className="hero-content">
        <h1 className="hero-title">
          <span className="letter-blue">e</span>
          <span className="letter-red">k</span>
          <span className="letter-blue">s</span>
          <span className="letter-blue"> construction</span>
        </h1>
        <p className="hero-subtitle">Feel the happiness in your Home</p>
        <button className="scroll-indicator" onClick={handleScrollDown} aria-label="Scroll down">
          <span className="scroll-arrow">&#8964;</span>
        </button>
      </div>
    </section>
  );
}

export default HeroSection;